<template>
  <basic-container>
    <div class="factoring-contract-detail">
      <div class="inner-con">
        <div class="project-title">
          {{ basicInfoData.contractName }}
          <!-- <span v-if="basicInfoData.contractName" class="contract_name"
            >({{ basicInfoData.contractName }})</span
          > -->
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="支付计划" name="first">
            <InfoContainer
              style="margin-top: 20px"
              :infoTitle="InfoContainerConfig['infoTitle']"
              :contentConfig="InfoContainerConfig['infoContent']"
              class="comment-container "
            >
              <template slot="basicInfo">
                <CommonDetail
                  :configArray="formConfig"
                  :initValue="basicInfoData"
                  :showNull="false"
                />
                <EarnoutTable :basicInfoData="basicInfoData" ></EarnoutTable>
              </template>
            </InfoContainer>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </basic-container>
</template>
<script>
import { earnoutDetailConfig, earnoutDetailListConfig } from "./config.js";
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommonDetail from "@/views/factoring/overdueManage/commonDetail";
import * as api from "@/api/factoring/factoringScheme";
import util from "@/mixins/util";
import EarnoutTable from "./components/earnoutTable";
export default {
  name: "earnoutDetail",
  mixins: [util],
  data() {
    return {
      activeName: "first",
      formConfig: earnoutDetailConfig(this.getMoney, this.dateConvert),
      tableConfig: earnoutDetailListConfig(this.getMoney, this.dateConvert),
      basicInfoData: {
        planList: [],
      },
      detail: {},
      InfoContainerConfig: {
        infoTitle: "保理支付计划",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      dataList: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      tableForm: {},
    };
  },
  components: {
    InfoContainer,
    CommonDetail,
    EarnoutTable,
  },

  watch: {},
  mounted() {
    this.id = this.$route.params.id;
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let res = await api.getDetailPlanView({ rentId: this.id });
      if (res.data.code == 200) {
        let  basicInfoData = res.data.data
        basicInfoData.leaseTotal=basicInfoData.planList.length
        this.basicInfoData = basicInfoData;
      } else {
        this.$message.error(res.data.message);
      }
    },
    
  },
};
</script>

<style lang="scss" scoped>
.contract_name {
  font-size: 14px;
  font-weight: 400;
}
.factoring-contract-detail {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  /deep/.item-label {
    font-weight: 400;
    font-size: 13px !important;
    color: #999999;
    text-align: right;
    min-width: 85px;
    padding-right: 12px;
  }
  /deep/.item-value {
    font-size: 13px !important;
    font-weight: 400;
    color: #333;
    flex: 1;
  }  
  .inner-con {
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }
    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .project-status {
      .status-title {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }
  .comment-container {
    margin-top: 20px;
    /deep/.detail-one {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }
    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }
 
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #f56c6c;
  }
  .color_4::before {
    background: #f56c6c;
  }
  /deep/.el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  /deep/.el-tabs__item.is-active {
    background: none;
  }
  /deep/.el-tabs__header {
    margin: 0px;
  }
  /deep/ .avue-form__menu--center {
    display: none;
  }
}
/deep/.el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
/deep/ .avue-form__menu--center {
  display: none;
}
</style>